/* Vigie des Bois — offres des fiches produit reprises de bramecam.com :
   packs multi-caméras (codes de remise), formules caméra + accessoires, achat en lot. Thème Concept. */
(function () {
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  function money(cents) {
    return (Number(cents || 0) / 100).toFixed(2).replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, ' ') + '€';
  }
  async function addToCart(items, code) {
    if (code) await fetch(root + 'discount/' + encodeURIComponent(code), { credentials: 'same-origin' });
    var res = await fetch(root + 'cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    });
    var data = await res.json();
    if (!res.ok) throw new Error(data.description || data.message || 'Ajout impossible.');
    document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { open: true } }));
    return data;
  }
  async function qtyInCart(id) {
    var c = await fetch(root + 'cart.js').then(function (r) { return r.json(); });
    return (c.items || []).reduce(function (n, it) { return it.variant_id === id ? n + it.quantity : n; }, 0);
  }

  /* 1. Pack 1 / 2 / 3 caméras (caméra 4G) */
  function initPack(el) {
    if (el.dataset.ready) return; el.dataset.ready = '1';
    var codes = JSON.parse((el.querySelector('[data-bc-codes]') || { textContent: '{}' }).textContent);
    var variant = Number(el.getAttribute('data-variant'));
    var radios = [].slice.call(el.querySelectorAll('.bc-pack__radio'));
    var cta = el.querySelector('[data-bc-add]'), label = el.querySelector('[data-bc-label]'), msg = el.querySelector('[data-bc-msg]');
    var note = msg ? msg.textContent : '';
    function sel() { return radios.filter(function (r) { return r.checked; })[0] || radios[0]; }
    function sync() { if (label && sel()) label.innerHTML = sel().getAttribute('data-label'); }
    radios.forEach(function (r) { r.addEventListener('change', sync); });
    if (cta) cta.addEventListener('click', async function () {
      var wanted = Number(sel().getAttribute('data-qty')); cta.disabled = true;
      if (msg) { msg.className = 'bc-pack__note'; msg.textContent = 'Ajout en cours…'; }
      try {
        var total = (await qtyInCart(variant)) + wanted;
        var code = total >= 3 ? codes['3'] : (total === 2 ? codes['2'] : '');
        await addToCart([{ id: variant, quantity: wanted }], code);
        if (msg) msg.textContent = note;
      } catch (e) { if (msg) { msg.className = 'bc-pack__note is-error'; msg.textContent = e.message; } }
      finally { cta.disabled = false; sync(); }
    });
    sync();
  }

  /* 2. Formules (caméra seule / pack prêt à filmer / duo terrain), config JSON data-bc-config */
  function initBundle(el) {
    if (el.dataset.ready) return; el.dataset.ready = '1';
    var cfg = JSON.parse(el.querySelector('[data-bc-config]').textContent);
    var main = cfg.main; // {id, price, compare_at_price, available}
    var radios = [].slice.call(el.querySelectorAll('input[name^="bc-offer-"]'));
    var addon = el.querySelector('[data-bc-addon]'), btn = el.querySelector('[data-bc-submit]'), msg = el.querySelector('[data-bc-message]');
    function key() { var r = radios.filter(function (x) { return x.checked; })[0] || radios[0]; return r && r.dataset.offer; }
    function totals(k) {
      var o = cfg.offers[k]; if (!o) return { price: 0, compare: 0 };
      var price = main.price * o.mainQty, compare = (o.mainCompare > 0 ? o.mainCompare : Math.max(main.compare_at_price || 0, main.price)) * o.mainQty;
      if (o.accessory) { price += o.accessory.price * o.accessoryQty; compare += Math.max(o.accessory.compare_at_price || 0, o.accessory.price) * o.accessoryQty; }
      return { price: price, compare: compare };
    }
    function update() {
      el.querySelectorAll('[data-bc-offer-card]').forEach(function (card) {
        var k = card.dataset.bcOfferCard, t = totals(k), cmp = card.querySelector('[data-bc-compare]'), sav = card.querySelector('[data-bc-saving]');
        card.querySelector('[data-bc-price]').textContent = money(t.price);
        if (cmp) { cmp.textContent = t.compare > t.price ? money(t.compare) : ''; cmp.hidden = !(cfg.showCompare && t.compare > t.price); }
        if (sav) { sav.textContent = t.compare > t.price ? cfg.savingText.replace('[amount]', money(t.compare - t.price)) : ''; sav.hidden = !(cfg.showSavings && t.compare > t.price); }
        var z = card.querySelector('[data-bc-zone]'); if (z) z.textContent = cfg.zoneText.replace('[amount]', money(Math.round(t.price / Math.max(1, cfg.offers[k].mainQty))));
        var av = card.querySelector('[data-bc-availability]'); if (av) av.textContent = cfg.availableText;
        card.classList.toggle('is-selected', card.querySelector('input').checked);
      });
      var k = key(), t = totals(k), extra = addon && addon.checked && cfg.addon ? cfg.addon.price * (cfg.addonQty || 1) : 0;
      btn.textContent = (cfg.offers[k] ? cfg.offers[k].buttonLabel : cfg.defaultButtonLabel) + ' — ' + money(t.price + extra);
    }
    radios.forEach(function (r) { r.addEventListener('change', update); });
    if (addon) addon.addEventListener('change', update);
    btn.addEventListener('click', async function () {
      var o = cfg.offers[key()]; if (!o) return;
      var items = [{ id: main.id, quantity: o.mainQty }];
      if (o.accessory && o.accessoryQty) items.push({ id: o.accessory.id, quantity: o.accessoryQty });
      if (addon && addon.checked && cfg.addon) items.push({ id: cfg.addon.id, quantity: cfg.addonQty || 1 });
      btn.disabled = true; var prev = btn.textContent; btn.textContent = cfg.loadingText;
      msg.className = 'bramecam-bundle__message'; msg.textContent = '';
      try { await addToCart(items, o.code); msg.textContent = cfg.successText; msg.classList.add('is-success'); }
      catch (e) { msg.textContent = e.message || cfg.genericError; msg.classList.add('is-error'); btn.textContent = prev; }
      finally { btn.disabled = false; update(); }
    });
    update();
  }

  /* 3. Achat en lot (cartes mémoire, lecteur) : 1 à 4 articles, code de remise par palier */
  function initQty(el) {
    if (el.dataset.ready) return; el.dataset.ready = '1';
    var variant = Number(el.dataset.variant), radios = [].slice.call(el.querySelectorAll('input[type=radio]')), btn = el.querySelector('[data-vdb-qty-add]');
    function sel() { return radios.filter(function (r) { return r.checked; })[0] || radios[0]; }
    function sync() { radios.forEach(function (r) { r.closest('label').classList.toggle('is-selected', r.checked); }); btn.textContent = 'Ajouter au panier — ' + sel().dataset.total; }
    radios.forEach(function (r) { r.addEventListener('change', sync); });
    btn.addEventListener('click', async function () {
      btn.disabled = true;
      try { await addToCart([{ id: variant, quantity: Number(sel().value) }], sel().dataset.code || ''); }
      catch (e) { alert(e.message); } finally { btn.disabled = false; sync(); }
    });
    sync();
  }

  function init(scope) {
    (scope || document).querySelectorAll('[data-bc-pack]').forEach(initPack);
    (scope || document).querySelectorAll('[data-bramecam-bundle]').forEach(initBundle);
    (scope || document).querySelectorAll('[data-vdb-qty]').forEach(initQty);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); }); else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
